import React from 'react';

import type { HeadingLevel } from '.';

type HeadingContextValue = {
  baseLevel?: HeadingLevel;
};

const HeadingContext = React.createContext<HeadingContextValue>({});

type HeadingProviderProps = HeadingContextValue & {
  children: React.ReactNode;
};

export const HeadingProvider: React.FC<HeadingProviderProps> = ({ baseLevel = 1, children }) => {
  const { baseLevel: baseLevelFromParentProvider } = useHeading();

  const newBaseLevel: HeadingLevel = baseLevelFromParentProvider
    ? (Math.min(baseLevelFromParentProvider + baseLevel - 1, 6) as HeadingLevel)
    : baseLevel;

  return <HeadingContext.Provider value={{ baseLevel: newBaseLevel }}>{children}</HeadingContext.Provider>;
};

export const useHeading = (): HeadingContextValue => React.useContext(HeadingContext);
